import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {InputPrimitiveComponent} from '@tisa-group/client-ui/components/inputs/input-primitive';

@Component({
  selector: 'tisa-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputTextComponent extends InputPrimitiveComponent<string> {
  @Input()
  readonly = false;

  @Input()
  type: 'text' | 'search' = 'text';

  get placeholderLabel(): string {
    if (!this.placeholder) return '';

    return this.required ? this.placeholder + '*' : this.placeholder;
  }
}
